<app-ace-select #zonenameSelect
                [appendTo]="appendTo"
                [items]="zonenames"
                [bindValue]="bindToZoneNameId ? 'zone_name_id' : null"
                [bindLabel]="'zone_name'"
                [placeholder]="placeholder"
                [multiSelect]="multiSelect"
                [maxSelectedLabels]="maxSelectedLabels"
                [hideSelected]="false"
                [loading]="loading"
                (touched)="onTouched()"
                (openEvent)="onOpen()"
                (closeEvent)="onClose()">

  <ng-template #optionTemplate let-zonename="item">
    @if (!showSite) {
      <div class="ng-value-label">
        <div>{{ zonename.zone_name }}</div>
      </div>
    } @else {
      <div class="row ng-value-label">
        <div class="col">
          <div>{{ zonename.zone_name }}</div>
        </div>
        <div class="col">
          <div class="float-end text-secondary smaller-font pt-1">{{ zonename['site_name'] }}</div>
        </div>
      </div>
    }
  </ng-template>

</app-ace-select>

@if (showSelectAll) {
  <div>
    <button class="btn btn-sm btn-link p-0" type="button" (click)="selectAll($event)">{{ 'Select All' | messageTranslate }}</button>
  </div>
}
